import { render, staticRenderFns } from "./aBonus.vue?vue&type=template&id=3613aec0&scoped=true"
import script from "./aBonus.vue?vue&type=script&lang=js"
export * from "./aBonus.vue?vue&type=script&lang=js"
import style0 from "./aBonus.vue?vue&type=style&index=0&id=3613aec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613aec0",
  null
  
)

export default component.exports